import { Slide } from "@jelly/lesson";

import powertrain from "./components/powertrain";
import wind from "./components/wind";
import tires from "./components/tires";

const principle: Slide = {
  title: "Sound Sources",
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controlsPosition: "bottom",
      controls: [
        {
          type: "button",
          items: [{ name: "Powertrain" }, { name: "Wind" }, { name: "Tires / Road" }],
          options: {},
        },
      ],
      components: [powertrain, wind, tires],
      extraContent: [[]],
    },
  },
};

export default principle;
